import React from 'react';
import { AppLogo } from '@/config';
import { useAppContext } from '@/contexts/AppContext';
import { AppUrls } from '@/urls';
import { Link } from 'react-router-dom';
import ChangePasswordModal from '../Modals/ChangePasswordModal';
import UpdateAgentProfileModal from '../Modals/UpdateAgentProfileModal';
import { DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';
import { useTranslation } from 'react-i18next';

export default function AgentHeader() {
  const { t } = useTranslation();
  const { logout } = useAppContext();
  const [displayChangePassword, setDisplayChangePassword] = React.useState<boolean>(false);
  const [displayUpdateProfile, setDisplayUpdateProfile] = React.useState<boolean>(false);
  return (
    <>
      <header className={`header -dashboard is-sticky bg-white`}>
        <div className="header__container px-30 sm:px-20">
          <div className="-left-side">
            <Link to={AppUrls.HomePage} className="header-logo">
              <AppLogo />
            </Link>
          </div>

          <div className="row justify-between items-center pl-60 lg:pl-20">
            <div className="col-auto"></div>
            <div className="col-auto">
              <div className="d-flex items-center">
                <div className="header-menu">
                  <div className="header-menu__content">
                    <nav className="menu js-navList">
                      <div className={`d-flex items-center`}>
                        <UncontrolledDropdown className="shadow transition-cubic rounded-100 p-0">
                          <DropdownToggle tag="button">
                            <img
                              src="/static/images/icons/person.svg"
                              alt="user"
                              style={{ border: '2px solid #3554d1', padding: 5 }}
                              className="icon-user size-40 rounded-full object-cover"
                            />
                          </DropdownToggle>
                          <DropdownMenu className="w-250px">
                            <div className="px-10 py-20">
                              <div className="pb-10">
                                <button
                                  className="d-flex items-center"
                                  style={{ justifyContent: 'flex-start' }}
                                  onClick={e => {
                                    e.preventDefault();
                                    setDisplayUpdateProfile(true);
                                  }}
                                >
                                  <i className="icon-user text-20 px-15 text-blue-1" />
                                  {t('headerCpn_Profile')}
                                </button>
                              </div>
                              <div className="pb-10">
                                <button
                                  className="d-flex items-center"
                                  style={{ justifyContent: 'flex-start' }}
                                  onClick={e => {
                                    e.preventDefault();
                                    setDisplayChangePassword(true);
                                  }}
                                >
                                  <img src="/static/images/icons/password.svg" alt="Agent Portal" className="size-20 mr-15 ml-15  text-dark-1 " />
                                  {t('headerCpn_ChangePassword')}
                                </button>
                              </div>

                              <div>
                                <button className="d-flex items-center" style={{ justifyContent: 'flex-start' }} onClick={logout}>
                                  <img src="/static/images/icons/log-out.svg" alt="Logout" className="  px-15 text-dark-1" />
                                  {t('base.Logout')}
                                </button>
                              </div>
                            </div>
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      </div>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {displayChangePassword ? <ChangePasswordModal onClose={() => setDisplayChangePassword(false)} /> : null}
        {displayUpdateProfile ? <UpdateAgentProfileModal onClose={() => setDisplayUpdateProfile(false)} /> : null}
      </header>
    </>
  );
}
